import { INTERACTION_BUFFER_SIZE } from 'data/error-log-constants';
import { InteractionType } from 'types/error-log';
import { describeElement } from 'utils/error-log/describe-element';
import { nextSequence } from 'utils/error-log/sequence';

const RECORDED_KEYS = new Set([
  'Enter',
  'Escape',
  'Tab',
  'Backspace',
  'Delete'
]);

const interactions: InteractionType[] = [];
let installed = false;

function record(interaction: InteractionType) {
  interactions.push(interaction);
  if (interactions.length > INTERACTION_BUFFER_SIZE) {
    interactions.shift();
  }
}

function handleClick(event: MouseEvent) {
  const target = describeElement(event.target);
  if (!target) {
    return;
  }
  record({ id: nextSequence(), timestamp: Date.now(), type: 'click', target });
}

function handleKeydown(event: KeyboardEvent) {
  if (!RECORDED_KEYS.has(event.key)) {
    return;
  }
  const target = describeElement(event.target);
  if (!target) {
    return;
  }
  record({
    id: nextSequence(),
    timestamp: Date.now(),
    type: 'keydown',
    key: event.key,
    target
  });
}

export function installInteractionRecorder() {
  if (installed || typeof document === 'undefined') {
    return;
  }
  installed = true;
  document.addEventListener('click', handleClick, true);
  document.addEventListener('keydown', handleKeydown, true);
}

export function getRecentInteractions(): InteractionType[] {
  return [...interactions];
}

export function getLastInteraction(): InteractionType | null {
  return interactions[interactions.length - 1] ?? null;
}

export function resetInteractionRecorder() {
  interactions.length = 0;
}
